import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface CardListStyles {
    gridContainer?: GridContainerProps;
    gridContainerTableView?: GridContainerProps;
}

export const cardListStyles: CardListStyles = {
    gridContainer: {
        gap: 40,
    },
    gridContainerTableView: {
        gap: 0,
        css: css`
            border-left: 1px solid ${getColor("common.border")};
            border-right: 1px solid ${getColor("common.border")};
        `,
        offsetProps: { style: { width: "100%" } },
    },
};

const mapStateToProps = (state: ApplicationState) => {
    return {
        view: state.pages.productList.view,
    };
};

type Props = ReturnType<typeof mapStateToProps> & { extendedStyles?: CardListStyles; css?: StyledProp };

const CardList: FC<Props> = ({ extendedStyles, view, children, ...otherProps }) => {
    const [styles] = useState(() => mergeToNew(cardListStyles, extendedStyles));

    return (
        <GridContainer {...(view === "Table" ? styles.gridContainerTableView : styles.gridContainer)} {...otherProps}>
            {children}
        </GridContainer>
    );
};

export default connect(mapStateToProps)(CardList);
